/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css } from "@panda/css";

export const styled = css({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	flex: "50%",

	"& .image-holder, & .asset-wrap": {
		maxWidth: `cosmos.article.sm`,
		aspectRatio: "16/9",
		position: "relative",
		mdDown: {
			maxWidth: "100%",
		},
	},

	"& .image-holder": {
		overflow: "visible",
	},

	"& .asset-wrap": {
		overflow: "hidden",
		borderRadius: "eds.dimension.24",

		"& img, & video": {
			transition: "transform token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)",
		},
	},

	"& .cosmos-asset": {
		position: "relative",
		zIndex: 2,
		borderRadius: "eds.dimension.24",
		w: "full",
		h: "full",
		objectFit: "cover",
	},

	"& .cosmos-attribution": {
		zIndex: 3,
	},
});
